import React from 'react';
import { useCustomViewsContext } from '../context/CustomViewsContext';
import { UpdateFooter } from './footers/UpdateFooter';
import { CreateFooter } from './footers/CreateFooter';
import { EditFooter } from './footers/EditFooter';
import { DefaultFooter } from './footers/DefaultFooter';

export const DropdownFooter: React.FC = () => {
  const { customViewsState } = useCustomViewsContext();
  if (!customViewsState.isEdit) {
    return <DefaultFooter />;
  }
  if (customViewsState.updatingView) {
    return <UpdateFooter />;
  }
  if (customViewsState.isCreate) {
    return <CreateFooter />;
  }
  return <EditFooter />;
};
